import { styled } from "@mui/material/styles"

import Row from "../../common/components/Row"

export default styled(Row)(({ theme }) => ({
  alignItems: "center",
  marginBottom: theme.spacing(2),
}))
